/* eslint-disable react-hooks/exhaustive-deps */
import { ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import SectionIsEdit from "../section/SectionIsEdit"
import DefaultLandingFooter from "./DefaultLandingFooter"
import LandingDragContainer from "./LandingDragContainer"
import LandingFooter from "./LandingFooter"
import SectionAddButton from "./SectionAddButton"
import { useEffect, useState } from "react"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */ 
export interface iLandingSectionsIsEditProps {
    sections: ILandingSection[]
}
const LandingSectionsIsEdit = ({ ...props }: iLandingSectionsIsEditProps): JSX.Element => {
    const [sections, setSections] = useState<ILandingSection[]>( props.sections )
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection[] = currentLanding.sections 
                if( sec.length !== sections.length ) { 
                    setSections(() => {
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, []) 

    return <LandingDragContainer> 
        {
            !!sections.length
                ?
                    <div className="landing-sections-is-edit h-100 " data-length={ sections.length }>
                        {
                            sections.map(( section, i ) => <SectionIsEdit i={ i } section={ section } key={ section.id || i } /> )
                        }
                        <div className="position-relative">
                            <SectionAddButton i={ sections.length } isLast />
                        </div> 
                        <LandingFooter />
                    </div>
                :
                <DefaultLandingFooter />
        }
    </LandingDragContainer>
}
export default LandingSectionsIsEdit